// extracted by mini-css-extract-plugin
export default {"mainLayout":"mainLayout__YTg2O","withTopBorder":"withTopBorder__M2UwY","onlyMobile":"onlyMobile__OGJjO"};